import { createAction } from '@reduxjs/toolkit';
import { CohortStats } from 'reducers/cohorts';
import { API, Cohort, CohortConfig, ErrorObject, UUID } from 'types';

export const fetchCohorts = createAction('COHORTS/FETCH_COHORTS');
export const fetchCohortsRequest = createAction('COHORTS/FETCH_COHORTS_REQUEST');
export const fetchCohortsFailure = createAction<ErrorObject>('COHORTS/FETCH_COHORTS_FAILURE');
export const fetchCohortsSuccess = createAction<API.WrappedAPIResponse<Cohort>>(
  'COHORTS/FETCH_COHORTS_SUCCESS'
);
export const fetchCohortsFulfill = createAction('COHORTS/FETCH_COHORTS_FULFILL');

type UpsetCohortPayload = {
  cohort: Partial<Omit<Cohort, 'config'>> & { config: Partial<CohortConfig> } & { file?: File };
  action?: 'add' | 'delete';
  redirectToImport?: boolean;
};

export const upsertCohort = createAction<UpsetCohortPayload>('COHORTS/UPSERT_COHORT');
export const upsertCohortRequest = createAction('COHORTS/UPSERT_COHORT_REQUEST');
export const upsertCohortFailure = createAction<ErrorObject>('COHORTS/UPSERT_COHORT_FAILURE');
export const upsertCohortSuccess = createAction<Cohort>('COHORTS/UPSERT_COHORT_SUCCESS');

export const deleteCohort =
  createAction<{ uuid: UUID; redirect?: boolean }>('COHORTS/DELETE_COHORT');
export const deleteCohortRequest = createAction('COHORTS/DELETE_COHORT_REQUEST');
export const deleteCohortFailure = createAction<ErrorObject>('COHORTS/DELETE_COHORT_FAILURE');
export const deleteCohortsuccess = createAction<{ uuid: UUID }>('COHORTS/DELETE_COHORT_SUCCESS');

export const fetchSingleCohort = createAction<{ cohortId: UUID }>('COHORTS/FETCH_SINGLE_COHORT');
export const fetchSingleCohortRequest = createAction('COHORTS/FETCH_SINGLE_COHORT_REQUEST');
export const fetchSingleCohortFailure = createAction<ErrorObject>(
  'COHORTS/FETCH_SINGLE_COHORT_FAILURE'
);
export const fetchSingleCohortSuccess = createAction<Cohort>('COHORTS/FETCH_SINGLE_COHORT_SUCCESS');

export const downloadCohortContract = createAction<{ cohortId: string }>(
  'COHORT/DOWNLOAD_CONTRACT'
);

export const fetchCohortStats = createAction<{ cohortId: UUID }>('COHORTS/FETCH_COHORT_STATS');
export const fetchCohortStatsRequest = createAction('COHORTS/FETCH_COHORT_STATS_REQUEST');
export const fetchCohortStatsFailure = createAction<ErrorObject>(
  'COHORTS/FETCH_COHORT_STATS_FAILURE'
);

export const fetchCohortStatsSuccess = createAction<CohortStats>(
  'COHORTS/FETCH_COHORT_STATS_SUCCESS'
);
